import { makeCall } from "./client";

export class EventsAPI {

  public getKnownEvents(app: string): Promise<any> {
    return makeCall(app, "get", `product/events/knownEvents`, {app});
  }

  public getEventIcons(app: string): Promise<any> {
    return makeCall(app, "get", `product/events/icons`, {app});
  }

  public createKnownEvent(app: string, data: object): Promise<any> {
    return makeCall(app, "post", `product/events/knownEvents`, data);
  }

  public updateKnownEvent(app: string, domain: string, data: object): Promise<any> {
    return makeCall(app, "patch", `product/events/knownEvents/${domain}`, data);
  }

  public deleteKnownEvent(app: string, domain: string, data: object): Promise<any> {
    return makeCall(app, "delete", `product/events/knownEvents/${domain}`, data);
  }
}


// WEBPACK FOOTER //
// ./src/api/events.ts